// extracted by mini-css-extract-plugin
export var fadeIn = "_k0-1";
export var modalContent = "_k0-3";
export var overlay = "_k0-0";
export var popoverContent = "_k0-2";
export var results = "_k0-5";
export var searchInputWrapper = "_k0-4";